import igcIcon from '../resources/images/transaction/cryptoIcons/igcIcon.svg';
import btcIcon from '../resources/images/transaction/cryptoIcons/btcIcon.svg';
import ethIcon from '../resources/images/transaction/cryptoIcons/ethIcon.svg';
import solIcon from '../resources/images/transaction/cryptoIcons/solIcon.svg';
import usdtIcon from '../resources/images/transaction/cryptoIcons/usdtIcon.svg';
import usdcIcon from '../resources/images/transaction/cryptoIcons/usdcIcon.svg';
import bnbIcon from '../resources/images/transaction/cryptoIcons/bnbIcon.svg';
import xrpIcon from '../resources/images/transaction/cryptoIcons/xrpIcon.svg';
import wbtcIcon from '../resources/images/transaction/cryptoIcons/wbtcIcon.svg';
import bscIcon from '../resources/images/transaction/cryptoIcons/bscIcon.svg';
import { isProd } from './app.constant';

// export const AssetCategoryType = {
//   Crypto: 'Crypto',
//   Fiat: 'Fiat',
// };

export const FiatCurrencyType = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
};

// export const CryptoSymbolType = {
//   BTC: 'BTC',
//   ETH: 'ETH',
//   USDT: 'USDT',
// };

// export const BlockchainNetworkType = {
//   Mainnet: 'mainnet',
//   Testnet: 'testnet',
// };

export const CryptoCurrencyType = {
  IGC: 'IGC',
  BTC: 'BTC',
  ETH: 'ETH',
  SOL: 'SOL',
  USDT: 'USDT',
  USDC: 'USDC',
  BNB: 'BNB',
  WBTC: 'WBTC',
  BTCB: 'BTCB',
  XRP: 'XRP',
  SIDA: 'SIDA',
};

export const CryptoDecimal = {
  IGC: 0,
  BTC: 8,
  WBTC: 8,
  ETH: 6,
  SOL: 6,
  USDT: 3,
  USDC: 3,
  BNB: 6,
  XRP: 6,
};

export const CryptoIcon = {
  [CryptoCurrencyType.IGC]: igcIcon,
  [CryptoCurrencyType.BTC]: btcIcon,
  [CryptoCurrencyType.ETH]: ethIcon,
  [CryptoCurrencyType.SOL]: solIcon,
  [CryptoCurrencyType.USDT]: usdtIcon,
  [CryptoCurrencyType.USDC]: usdcIcon,
  [CryptoCurrencyType.BNB]: bnbIcon,
  [CryptoCurrencyType.XRP]: xrpIcon,
  [CryptoCurrencyType.WBTC]: wbtcIcon,
};

export const BlockchainNameType = {
  bitcoin: 'bitcoin',
  ethereum: 'ethereum',
  solana: 'solana',
  bsc: 'bsc',
  xrp: 'xrp',
};

export const BlockChainIcon = {
  [BlockchainNameType.ethereum]: ethIcon,
  [BlockchainNameType.bitcoin]: btcIcon,
  [BlockchainNameType.solana]: solIcon,
  [BlockchainNameType.bsc]: bscIcon,
  [BlockchainNameType.xrp]: xrpIcon,
};

export const NativeTokens = {
  [BlockchainNameType.ethereum]: CryptoCurrencyType.ETH,
  [BlockchainNameType.bitcoin]: CryptoCurrencyType.BTC,
  [BlockchainNameType.solana]: CryptoCurrencyType.SOL,
  [BlockchainNameType.bsc]: CryptoCurrencyType.BNB,
  [BlockchainNameType.xrp]: CryptoCurrencyType.XRP,
};

// Mainnet Token Addresses
const TokenAddressesMainnet = {
  [CryptoCurrencyType.USDT]: {
    [BlockchainNameType.ethereum]: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    [BlockchainNameType.solana]: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    [BlockchainNameType.bsc]: '0x55d398326f99059fF775485246999027B3197955',
  },

  [CryptoCurrencyType.USDC]: {
    [BlockchainNameType.ethereum]: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    [BlockchainNameType.solana]: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    [BlockchainNameType.bsc]: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    [BlockchainNameType.xrp]: 'rcEGREd8NmkKRE8GE424sksyt1tJVFZwu',
  },
  [CryptoCurrencyType.IGC]: {
    [BlockchainNameType.ethereum]: '0x37607EcE7f0B534AD64d4827d38B466696Ac3ff9',
    [BlockchainNameType.solana]: '3P5p5rAha7sVgSFHKQ5mwicBxRetbMqdzQMkHNJi8K7c',
    [BlockchainNameType.bsc]: '0xae62E03fCF68A5d48e5fa8608D9093b4B7d6313d',
    [BlockchainNameType.xrp]: 'raP6XZypcFR1WkDzaKjv91FtYRCURvePWW',
  },

  [CryptoCurrencyType.BNB]: {
    [BlockchainNameType.ethereum]: '0xB8c77482e45F1F44dE1745F52C74426C631bDd52',
  },

  [CryptoCurrencyType.BTC]: {
    [BlockchainNameType.ethereum]: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    [BlockchainNameType.solana]: '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh',
    [BlockchainNameType.bsc]: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
  },
};

// Testnet/Devnet Token Addresses
const TokenAddressesTestnet = {
  [CryptoCurrencyType.USDC]: {
    [BlockchainNameType.ethereum]: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
    [BlockchainNameType.solana]: '4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU',
    [BlockchainNameType.bsc]: '0x64544969ed7EBf5f083679233325356EbE738930',
    [BlockchainNameType.xrp]: 'rHuGNhqTG32mfmAvWA8hUyWRLV3tCSwKQt',
  },
};

// TokenAddresses automatically switches between mainnet and testnet based on isProd
export const TokenAddresses = isProd ? TokenAddressesMainnet : TokenAddressesTestnet;

// export const ChainToken = {
//   [BlockchainNameType.ethereum]: [
//     CryptoCurrencyType.USDT,
//     CryptoCurrencyType.ETH,
//     CryptoCurrencyType.BNB,
//     CryptoCurrencyType.WBTC,
//   ],
//   [BlockchainNameType.bsc]: [CryptoCurrencyType.BNB],
//   [BlockchainNameType.solana]: [CryptoCurrencyType.SOL, CryptoCurrencyType.USDT],
// };

/** Current Update - 21/01/2025
 * ETH - chain ethereum
 * WBTC - chain ethereum, solana, bsc
 * USDT - chain ethereum, solana, bsc
 * USDC - chain ethereum, solana, bsc
 * BNB - chain ethereum, bsc
 * SOL -  chain solana
 * XRP - chain xrp
 */

// Mainnet cryptoToBlockchain
export const cryptoToBlockchainMainnet = {
  [CryptoCurrencyType.ETH]: [BlockchainNameType.ethereum],
  [CryptoCurrencyType.BTC]: [
    BlockchainNameType.ethereum,
    BlockchainNameType.solana,
    BlockchainNameType.bsc,
  ],
  [CryptoCurrencyType.USDT]: [
    BlockchainNameType.ethereum,
    BlockchainNameType.solana,
    BlockchainNameType.bsc,
  ],
  [CryptoCurrencyType.USDC]: [
    BlockchainNameType.ethereum,
    BlockchainNameType.solana,
    BlockchainNameType.bsc,
  ],
  [CryptoCurrencyType.BNB]: [BlockchainNameType.ethereum, BlockchainNameType.bsc],
  [CryptoCurrencyType.SOL]: [BlockchainNameType.solana],
  [CryptoCurrencyType.XRP]: [BlockchainNameType.xrp],
  [CryptoCurrencyType.IGC]: [
    BlockchainNameType.ethereum,
    BlockchainNameType.solana,
    BlockchainNameType.bsc,
    BlockchainNameType.xrp,
  ],
};

// Testnet/Devnet cryptoToBlockchain
export const cryptoToBlockchainTestnet = {
  [CryptoCurrencyType.ETH]: [BlockchainNameType.ethereum],
  [CryptoCurrencyType.BNB]: [BlockchainNameType.bsc],
  [CryptoCurrencyType.SOL]: [BlockchainNameType.solana],
  [CryptoCurrencyType.XRP]: [BlockchainNameType.xrp],
  [CryptoCurrencyType.USDC]: [
    BlockchainNameType.ethereum,
    BlockchainNameType.solana,
    BlockchainNameType.bsc,
    BlockchainNameType.xrp,
  ],
};

// cryptoToBlockchain automatically switches between testnet and mainnet based on isProd
export const cryptoToBlockchain = isProd ? cryptoToBlockchainMainnet : cryptoToBlockchainTestnet;
